import { Node, mergeAttributes } from "@tiptap/core";

/**
 * Inline atom for ProcessWithAI needs_input placeholders:
 *   <span data-formula-pending="<calculationId>" contenteditable="false">⌛ formulaId</span>
 *
 * Bare spans are stripped by ProseMirror; this node preserves the chip through setContent.
 */
export const FormulaPendingChip = Node.create({
  name: "formulaPendingChip",

  group: "inline",
  inline: true,
  atom: true,
  selectable: true,
  draggable: false,

  addAttributes() {
    return {
      calculationId: {
        default: null,
        parseHTML: (element) =>
          element.getAttribute("data-formula-pending") || null,
        renderHTML: (attributes) => {
          if (!attributes.calculationId) return {};
          return {
            "data-formula-pending": String(attributes.calculationId),
          };
        },
      },
      formulaId: {
        default: "formula",
        parseHTML: (element) => {
          const raw = String(element.textContent || "").trim();
          return raw.replace(/^⌛\s*/, "").trim() || "formula";
        },
        renderHTML: () => ({}),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "span[data-formula-pending]",
        priority: 220,
      },
    ];
  },

  renderHTML({ node, HTMLAttributes }) {
    const formulaId = node.attrs.formulaId || "formula";
    return [
      "span",
      mergeAttributes(HTMLAttributes, {
        contenteditable: "false",
        class: "formula-pending-chip",
      }),
      `⌛ ${formulaId}`,
    ];
  },
});

export default FormulaPendingChip;
